'use client'

import { useEffect } from 'react'

// Splits the hero headline lines into per-letter spans for the hover
// effect. Runs after first paint on purpose: server-rendered plain text
// keeps the <h1> the LCP element; tiny per-letter boxes would not count.
// Only on devices that can hover, since phones never see the effect.
export default function HeroLetterSplit() {
  useEffect(() => {
    if (!window.matchMedia('(hover: hover)').matches) return

    const split = () => {
      document.querySelectorAll<HTMLElement>('.hero-line[data-split]').forEach((line) => {
        const text = line.textContent ?? ''
        const chars = Array.from(text)
        const sr = document.createElement('span')
        sr.className = 'sr-only'
        sr.textContent = text
        const visual = document.createElement('span')
        visual.setAttribute('aria-hidden', 'true')
        visual.style.setProperty('--n', String(chars.length))
        let i = 0
        text.split(' ').forEach((word, w) => {
          if (w > 0) visual.append(' ')
          const wordEl = document.createElement('span')
          wordEl.className = 'whitespace-nowrap'
          for (const ch of Array.from(word)) {
            const c = document.createElement('span')
            c.className = 'hero-char'
            c.style.setProperty('--i', String(i++))
            c.textContent = ch
            wordEl.append(c)
          }
          visual.append(wordEl)
        })
        line.replaceChildren(sr, visual)
        line.removeAttribute('data-split')
        line.classList.add('hero-line-split')
      })
    }

    const idle = typeof window.requestIdleCallback === 'function'
    const id = idle ? window.requestIdleCallback(split, { timeout: 3000 }) : window.setTimeout(split, 1500)
    return () => (idle ? window.cancelIdleCallback(id) : window.clearTimeout(id))
  }, [])

  return null
}
